
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/charts/axis-config",
      function () {
        return require("private-next-pages/x/api/charts/axis-config.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/charts/axis-config"])
      });
    }
  